import { AlertTriangle, X } from 'lucide-react';

const ProctorWarnings = ({ warnings, onDismiss }) => {
  if (warnings.length === 0) return null;

  return (
    <div className="fixed top-20 right-4 z-40 space-y-2">
      {warnings.map((warning) => (
        <div
          key={warning.id}
          className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-lg shadow-lg max-w-sm"
        >
          <div className="flex items-start">
            <AlertTriangle className="h-5 w-5 text-yellow-400 mt-0.5 mr-3 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm text-yellow-800 font-medium">
                Proctoring Alert
              </p>
              <p className="text-sm text-yellow-700 mt-1">
                {warning.message}
              </p>
            </div>
            <button
              onClick={() => onDismiss?.(warning.id)}
              className="ml-2 text-yellow-400 hover:text-yellow-600"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProctorWarnings;
